import { createContext } from "react"

export const MessagesContext = createContext()

export const StreamingContext = createContext()
